import { Container, Col } from 'reactstrap';
import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import styles from './styles.module.scss';

// Convert a hex colour variant into a light, translucent rgba tint for the open state
const hexToRgba = (hex, alpha) => {
    if (!hex) return undefined;
    const h = hex.replace("#", "");
    const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
    const num = parseInt(full, 16);
    if (Number.isNaN(num)) return undefined;
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const Accordions = ({
    className,
    title,
    heading,
    titleColour,
    items
}) => {

    // Create a state variable to track the open accordion item and its toggle class
    const [openItem, setOpenItem] = useState(null);

    const classToggle = (id) => {
        // If the clicked item is already open, close it
        if (openItem === id) {
            setOpenItem(null);
        } else {
            // Otherwise, open the clicked item
            setOpenItem(id);
        }
    };

    const [open, setOpen] = useState('');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className={`${styles.root} ${className} bg-light`}>
            <Container className="py-4 py-md-5">
                {title &&
                    <div className="mb-5 heading">
                        <h2
                            className={`${heading} m-0`}
                            style={titleColour ? { color: titleColour } : null}
                        >
                            {title}
                        </h2>
                    </div>
                }
                <Accordion open={open} toggle={toggle} className="row m-0">
                    {items?.map((item, index) => (
                        <Col key={index} md={6} lg={4} className={`mb-4 item rounded-4 ${open === `${index}` ? "open" : ""}`} style={{ "--icon-color": item.colorVariant || undefined, "--icon-color-light": hexToRgba(item.colorVariant, 0.2) }}>
                            <AccordionItem className={`border-0 bg-transparent position-relative`}>
                                {/* <AccordionHeader
                                    targetId={`${index}`}
                                    tag="div"
                                    className={`mb-4`}
                                    onClick={() => classToggle(`${index}`)}
                                >
                                    {item?.title}
                                </AccordionHeader> */}
                                                               <AccordionHeader
                                    targetId={`${index}`}
                                    tag="div"
                                    className={`${item.url_slug ? "stretched-link" : ""} mb-4`}
                                    onClick={() => { item.url_slug ? window.location.href = item.url_slug : classToggle(`${index}`); }}
                                >
                                    {item?.title}
                                </AccordionHeader>
                                {item?.short_description &&
                                    <div dangerouslySetInnerHTML={{ __html: item?.short_description }} />
                                }
                                <AccordionBody accordionId={`${index}`}>
                                    {item?.content &&
                                        <div dangerouslySetInnerHTML={{ __html: item?.content }} />
                                    }
                                </AccordionBody>
                            </AccordionItem>
                        </Col>
                    ))}
                </Accordion>
            </Container>
        </section>
    )
}

export default Accordions;
